import { api } from './apiClient';
import type { AnimeDetails, MediaDetails, EpisodeSummary, MediaType } from '@/types/streaming';

export function getMediaDetails(type: MediaType, tmdbId: number): Promise<MediaDetails> {
  // type === 'anime' should never reach here; the anime path uses
  // getAnimeDetails() below. Narrow to the tmdb-keyed pair to avoid
  // accidentally hitting /api/media/anime/<tmdb-id>.
  if (type === 'anime') {
    return Promise.reject(new Error('use getAnimeDetails for anime'));
  }
  return api<MediaDetails>(`/api/media/${type}/${tmdbId}`, { auth: true });
}

export async function getSeasonEpisodes(tmdbId: number, season: number): Promise<EpisodeSummary[]> {
  const res = await api<{ episodes: EpisodeSummary[] }>(
    `/api/media/tv/${tmdbId}/season/${season}`,
    { auth: true },
  );
  return res.episodes;
}

export function getAnimeDetails(malId: number): Promise<AnimeDetails> {
  return api<AnimeDetails>(`/api/media/anime/${malId}`, { auth: true });
}
